export default __webpack_public_path__ + "static/media/g4.456acce0.png";